'use strict';

import totpTemplate from './totp.html';

export default angular
  .module('main.profile.tabs.totp', [])

  .directive('profileTotpTab', ($filter) => {
    return {
      restrict: 'E',
      template: totpTemplate,
      scope: {},
      controller: (
        $scope,
        $q,
        $filter,
        utils,
        ProfileDataProvider,
        ToastsService
      ) => {
        const $t = $filter('translate');
        $scope.dateFormatStr = $t('datetime.events.date');
        $scope.dataProvider = ProfileDataProvider.instance;

        angular.extend($scope, {
          onDeleteTotpFactorButtonClick: onDeleteTotpFactorButtonClick,
          onCreateTotpFactorButtonClick: onCreateTotpFactorButtonClick,
        });

        init();

        function init() {
          $scope.loading = true;
          initWatchers();

          $q.all([
            $scope.dataProvider.totpListResource.init(),
          ])
            .then(() => {
              initDataModel();
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initDataModel() {
          $scope.factors = angular.copy($scope.dataProvider.totpListResource.value || []);
        }

        function initWatchers() {
          $scope.$watch('dataProvider.totpListResource.value', (newVal, oldVal) => {
            if (newVal && newVal !== oldVal) {
              $scope.factors = angular.copy($scope.dataProvider.totpListResource.value || []);
            }
          });
        }

        function onDeleteTotpFactorButtonClick(factor) {
          if (!factor || !factor.name || $scope.loading) {
            return;
          }

          $('#remove-totp-factor-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#remove-totp-factor-dialog').modal('hide');

              $scope.loading = true;
              $scope.dataProvider.deleteTotpFactor(factor)
                .then(() => {
                  ToastsService.success(null, $t('profile.totp.delete.success'));
                  $scope.loading = false;
                  $scope.factors = $scope.factors.filter(f => f.name !== factor.name);
                }, (err) => {
                  $scope.loading = false;
                  utils.handleApiError(err);
                });
            }
          }).modal('show');
        }

        function onCreateTotpFactorButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.dataProvider.activeTab = 'addTotp';
        }

      }
    };
  })

  .name;
